// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CancelSubscriptionModal_wrapper__0uJf7"};